import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import API from "../../helpers/endpointservice";
import axios from "axios";
import $ from "jquery";
import Loader from "../../helpers/loader";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import moment from "moment";
class Category1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "categoryName",
      currentUser: "",
      pageNewCount: false,
      isCategory1Failed: false,
      isCategory1Loader: false,
      height: window.innerHeight,
      userId: 0,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      pageCount: 20,
      category1List: [],
      category1ArryList: [],
      currentPage: 1,
      perPage: 20,
      isSearch: false,
      totalCount: 0,
      searchInput: "",
      isToastError: false,
      addcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
        parentCategoryName: ""
      },
      editcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
        parentCategoryName: ""
      },
      categoryEmpty: [],
      isView: false,
      Category1LimitExceed: false
    };
  }
  componentDidMount() {
    let user = localStorage.getItem("UserId");
    let Rolevalue = localStorage.getItem("Role").split(",")[0];
    this.state.currentUser = Rolevalue;
    this.state.userId = user; //Change1
    this.state.currentUser = user;
    this.setState({}, () => {
      this.GetCategory1List();
    })
    $("body").removeClass("scrollhide");
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };
  GetCategory1List = () => {
    let apiUrl = `${API.GET_CATEGORY1}?sortBy=${this.state.sortBy}&isSortAscending=${this.state.order == "asc" ? true : false}&pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}`;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.isSearch ? { category1Name: this.state.searchInput } : {}
      data: { category1Name: this.state.searchInput }
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.category1List = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.isSearch = false;
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  sortTable = (name) => {
    if (this.state.category1List?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc"
          this.state.order = ordernew;
        }
        else {
          var ordernew = "asc"
          this.state.order = ordernew;
        }
      }
      else {
        this.state.sortBy = name;
        this.state.order = 'asc'
      }
      this.state.currentPage = 1;
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({}, () => {
        this.GetCategory1List()
      })
    }

  };
  fetchPaginationList = (currentpage, perpage) => {
    this.state.currentPage = currentpage;
    this.state.perPage = perpage;
    this.setState({}, () => {
      this.GetCategory1List()
    });

  };

  handlecategoryInputchange(e, field, type) {
    if (type === "Add") {
      if (e?.target?.value.trim().length > 250) {
        this.state.Category1LimitExceed = true;
        this.setState({});
      } else if (e?.target?.value?.trim()?.length <= 250) {
        this.state.addcategoryValue[field] = e.target.value;
        this.state.categoryEmpty = false;
        this.state.Category1LimitExceed = false;
        this.setState({});
      }
    } else if (type === "Edit") {
      if (e?.target?.value.trim().length > 250) {
        this.state.Category1LimitExceed = true;
        this.setState({});
      } else if (e?.target?.value?.trim()?.length <= 250) {
        this.state.editcategoryValue[field] = e.target.value;
        this.state.Category1LimitExceed = false;
        this.setState({});
      }
    }
  }
  category1Search = (e) => {
    this.setState({ searchInput: e?.target?.value })
  }

  OpenAddcategory1 = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("addCategory1Screen")
    );
    myOffcanvas.show();
    this.state.category1ArryList = [];
    this.state.Category1LimitExceed = false;
    this.setState({});
    $("body").addClass("scrollhide");
  };
  handleCheckbox = (x) => {
    const { category1ArryList } = this.state;
    if (category1ArryList?.length == 0) {
      category1ArryList.push(x);
    } else {
      if (
        category1ArryList && category1ArryList.filter((i) => i == x)?.length == 1
      ) {
        category1ArryList.map((i, ind) => i == x ? category1ArryList.splice(ind, 1) : "");
      } else {
        category1ArryList.push(x);
      }
    }
    this.setState({});
  };
  handleCheckboxTop = () => {
    let data = [];
    if (this.state.category1ArryList?.length != this.state.category1List?.length && this.state.category1ArryList?.length > 0 && this.state.category1List?.length > 0
    ) {
      this.state.category1List?.map((r) => data.push(r.categoryId));
    }
    if (
      this.state.category1ArryList?.length == 0 && this.state.category1List?.length > 0
    ) {
      this.state.category1List?.map((r) => data.push(r.categoryId));
    }
    if (
      this.state.category1ArryList?.length == this.state.category1List?.length && this.state.category1List?.length > 0
    ) {
      data = [];
    }
    this.state.category1ArryList = data;
    this.setState({});
  };

  GetCategoryValue = (isview, id) => {
    var ids = this.state.category1ArryList;
    var CategoryId = parseInt(ids.toString()) || parseInt(id);
    this.setState({ isCategory1Loader: true, isCategory1Failed: false, Category1LimitExceed: false });
    let apiUrl = `${API.GET_PARDICULAR_CATEGORY}?categoryId=${CategoryId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          const GetData = {
            categoryName: res.data.categoryName,
            categoryId: res.data.categoryId,
            isSubCategory: res.data.isSubCategory,
            parentCategoryName: "",
            parentCategoryId: 0,
            historyLog: res.data.historyLog
          };
          this.state.editcategoryValue = GetData;
          this.setState({});
        }
        const newLocal = "editCategory1Screen";
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById(newLocal)
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        this.setState({ isCategory1Loader: false, isCategory1Failed: false, isView: isview });
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory1Loader: false, isCategory1Failed: false, isView: false, historyLog: [] });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  AddCategory() {
    const { addcategoryValue, userId } = this.state;
    let Categoryadd =
    {
      categoryName: addcategoryValue.categoryName,
      isSubCategory: false,
      categoryId: 0,
      parentCategoryId: 0,
      parentCategoryName: "",
    };
    if (Categoryadd.categoryName !== "") {
      let apiurl1 = `${API.EXIST_CATEGORY}?categoryname=${Categoryadd.categoryName}&type=category1&id=${Categoryadd.categoryId}`;
      this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.POST_CATEGORY}?userId=${userId}`;
          this.setState({ isCategory1Loader: true, isCategory1Failed: false });
          axios({
            method: "POST",
            url: apiUrl,
            data: Categoryadd,
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearAddCategory1();
                this.GetCategory1List();
                toast.success("Category added successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });

                this.setState({
                  isCategory1Loader: false,
                  isCategory1Failed: false,
                });
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              console.log(error);
              this.setState({
                isCategory1Loader: false,
                isCategory1Failed: false,
              });
              // toast.error(
              //   "Failed to add category",
              //   { position: toast.POSITION.TOP_RIGHT, color: "#fff", }
              // );
              swal("Error!", "Something went wrong. Please try again.", "warning");
            });
        } else {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          toast.error(
            "This category name is already given. Please give another name.",
            {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            }
          );
        }
      });
    } else {
      this.state.categoryEmpty = true;
      this.setState({});
    }
  }
  UpdateCategory = () => {
    const { editcategoryValue, userId } = this.state;
    let Categoryedit =
    {
      categoryName: editcategoryValue.categoryName,
      isSubCategory: false,
      categoryId: editcategoryValue.categoryId,
      parentCategoryId: 0,
      parentCategoryName: ""
    };
    if (Categoryedit.categoryName !== "") {
      let apiurl1 = `${API.EXIST_CATEGORY}?categoryname=${Categoryedit.categoryName}&type=category1&id=${Categoryedit.categoryId}`;
      this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.PUT_CATEGORY}?userId=${userId}`;
          this.setState({ isCategory1Loader: true, isCategory1Failed: false });
          axios({
            method: "PUT",
            url: apiUrl,
            data: Categoryedit,
          })
            .then((res) => {
              if (res.data === true) {
                this.setState({ isCategory1Loader: false })
                this.GetCategory1List();
                this.clearCategory1Edit();
                toast.success("Category edited successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              console.log(error);
              // toast.error(
              //   "Failed to edit category.",
              //   {
              //     position: toast.POSITION.TOP_RIGHT,
              //     color: "#fff",
              //   }
              // );
              swal("Error!", "Something went wrong. Please try again.", "warning");
              this.setState({
                isCategory1Loader: false,
                isCategory1Failed: false,
              });
            });
        } else {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          toast.error(
            "This category name is already given. Please give another category name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else if (Categoryedit.categoryName === "") {
      this.state.categoryEmpty = true;
      this.setState({});
    }
  };
  OpenRemoveCategory1 = () => {
    var ids = this.state.category1ArryList;
    let apiurl1 = `${API.DOCUMENT_EXIST}?type=category1`;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    axios({
      method: "POST",
      url: apiurl1,
      data: ids,
    })
      .then((res) => {
        if (res.data?.length === 0) {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          let cancelPopup = new window.bootstrap.Modal(document.getElementById("CancelCourseScreen"));
          cancelPopup.show();
          $("body").addClass("scrollhide");
        } else {
          this.state.order = "desc";
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          toast.error(
            "Sorry you cannot delete the catagory when documents exist in it.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  cancelDeletePopup = () => {
    $("body").removeClass("scrollhide");
  };

  DeleteCategory = () => {
    const { userId, category1ArryList } = this.state;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    let apiUrl = `${API.DELETE_CATEORY}?userId=${userId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: category1ArryList,
    })
      .then((res) => {
        if (res.status === 200) {
          this.clearDeletedArray();
          this.GetCategory1List();
          toast.success("Category removed successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  ClearAddCategory1 = () => {
    this.state.categoryEmpty = false;
    let data = {
      categoryName: "",
      isSubCategory: false,
      categoryId: 0,
      parentCategoryId: 0,
      parentCategoryName: ""
    }
    this.state.addcategoryValue = data;
    this.setState({});
    $("#addCategory1Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    // this.GetCategory1List();
  };
  clearCategory1Edit = () => {
    this.state.categoryEmpty = false;
    this.state.category1ArryList = [];
    this.setState({});
    $("#editCategory1Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    // this.GetCategory1List();
  };
  clearDeletedArray = () => {
    $("body").removeClass("scrollhide");
    this.state.category1ArryList = [];
    this.setState({});
  };


  openSearchFilterListView = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("searchCategoryScreen")
    );
    myOffcanvas.show();
    // this.state.isAdd = false;
    // this.state.isEdit = false;
    this.state.isSearch = true;
    this.state.isFieldEmpty = false;
    $("body").addClass("scrollhide");
  }

  searchCategoryList = () => {
    if (this.state.searchInput?.trim() !== "") {
      this.state.isFieldEmpty = false;
      this.state.isRequestLoader = true;
      this.setState({})
      $("#searchCategoryScreen").removeClass('show');
      $("body").removeClass("scrollhide")
      this.GetCategory1List();
    }
    else {
      this.setState({ isFieldEmpty: true })
    }
  }

  clearSearchList = () => {
    this.setState({
      searchInput: "",
      isRequestLoader: true,
      isSearch: false
    }, () => this.GetCategory1List())
    $("#searchCategoryScreen").removeClass('show');
    $("body").removeClass("scrollhide")
  }

  render() {
    const { isMobile, isSmallMobile, isCategory1Loader, pageCount, isRadioMobile, sortBy, order, category1List, addcategoryValue, editcategoryValue, category1ArryList, pageNewCount } = this.state;
    const { menuToggle } = this.props;
    return (
      <>
        <Toaster />
        {$("#addCategory1Screen").hasClass("show") || $("#searchCategoryScreen").hasClass("show") || $("#editCategory1Screen").hasClass("show") ? (<div className="viewbar-overlay"></div>) : (<></>)}
        <div className={`${isMobile ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>
          <Loader isLoader={isCategory1Loader} />
          <div className="head-fixed-company">
            {isMobile == true ? (
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title">Category 1</div>
              </div>) : (
              <div className="title">
                <CommonIcon fileName="courseCategoryMaxIcon" />{" "}<span className="pl-10 head-span">Category 1</span>
              </div>)}
            <div className={`${isMobile ? "" : "pl-10"} border-bottom`}>
              <div className={`col-12 d-flex justify-content-start  ${isMobile ? "pr-0 pl-17" : "p-1 pl-10"}`}>
                <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.OpenAddcategory1()}>
                  <CommonIcon fileName="addIcon" /><span className={`subhead-span p-2`}>Add</span>
                </button>
                {category1ArryList?.length === 1 &&
                  <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.GetCategoryValue(false)}>
                    <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                  </button>}
                {category1ArryList?.length !== 0 &&
                  <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.OpenRemoveCategory1()}>
                    <CommonIcon fileName="RemoveIcon" /><span className={`subhead-span p-2`}>Remove</span>
                  </button>}
                <div
                  className={`position-absolute  end-0 ${isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"
                    }`}
                >
                  <button
                    className="displaybutton"
                    onClick={this.openSearchFilterListView}
                  >
                    <span>
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={`${isMobile ? "vendor-mobile-table1" : "vendor-table1"} table-responsive w-100`}>
            <div className={`table-fixed-header ${(isMobile ? "table-scroll-xy-mobile top-150px" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-training" : "table-scroll-xy top-upcoming-training")} table-list-view-bottom`} >
              <table className={`table  fileListTable2 table-borderless table-hover ${isMobile ? "" : ""} table-responsive`}>
                <thead>
                  <tr>
                    <td>
                      <input type="checkbox" name="request" checked={category1ArryList?.length !== 0 ? category1ArryList?.length === 1 ? false : (category1ArryList?.length == category1List?.length ? true : false) : false} onClick={() => this.handleCheckboxTop()} />
                    </td>
                    <td className="cursor-pointer" onClick={() => this.sortTable("categoryName")}>
                      <span className="pl-20">Categories</span>{sortBy === "categoryName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                    </td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {category1List?.length !== 0 ? (category1List?.map((item, index) => (
                    <tr key={index} className={`${category1ArryList?.filter((r) => r == item.categoryId)?.length > 0 ? "background-color-table" : ""}`}>
                      <td>
                        <input type="checkbox" name="request" className="checkboxes t-input" checked={category1ArryList?.filter((r) => r == item.categoryId)?.length > 0 ? true : false} onClick={() => this.handleCheckbox(item.categoryId)} />
                      </td>
                      <td className="min-width-skill-masterdata pl-20">
                        <span className="tablefilename cursor-pointer font-wei-600" onClick={() => this.GetCategoryValue(true, item.categoryId)} title={item.categoryName}>{item.categoryName}{" "}</span>
                      </td>
                      <td></td>
                    </tr>))) : (
                    <tr>
                      <td colSpan={4} className="table-nodata">
                        {category1List && "No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Add offcanvas */}
          <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="addCategory1Screen" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">Add category</h6>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas"
                onClick={() => this.ClearAddCategory1()}>
                <CommonIcon fileName="CrossIcon" />
              </button>{" "}
            </div>
            <div className="offcanvas-body px-4 pt-0">
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                  <div className="form-group">
                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName="courseCategoryIcon" />{" "}
                      <span className="pl-10 properties-search-span">Category 1</span> <span className="MuiFormHelperText-contained">*</span>
                    </label>
                    <input className={`form-control border-radius mt-2 font-size-12 ${this.state.categoryEmpty === true || this.state.Category1LimitExceed === true ? "Error-border" : ""}`}
                      onInput={(e) => this.handlecategoryInputchange(e, "categoryName", "Add")}
                      value={addcategoryValue.categoryName} />
                    {this.state.categoryEmpty === true ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)}
                    {this.state.Category1LimitExceed === true ? (
                      <span className="spanErrMsg">Value must be less than 250 characters</span>
                    ) : (<></>)}
                  </div>{" "}
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => this.AddCategory()}>
                  <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10">Submit</span>
                </button>
              </div>
            </div>
          </div>

          {/* Edit offcanvas */}
          <div className={`offcanvas offcanvas-end offcanvasStyle ${this.state.isView ? "audit-offcanvas" : ''}`} tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="editCategory1Screen" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
              <h6 id="offcanvasRightLabel" className="modal-title pr-10 fw-600">{this.state.isView ? "Category" : "Edit category"}</h6>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`}
                data-bs-dismiss="offcanvas">
                <CommonIcon fileName="CrossIcon" />
              </button>{" "}
            </div>
            <div className="offcanvas-body px-4 pt-0">
              {
                this.state.isView && <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : "pl-0"}`} onClick={() => this.GetCategoryValue(false, editcategoryValue.categoryId)}>
                  <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                </button>
              }
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                  <div className="form-group">
                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName="courseCategoryIcon" />{" "}
                      <span className="pl-10 properties-search-span">Category 1</span> <span className="MuiFormHelperText-contained">*</span>
                    </label>
                    <input className={`form-control border-radius mt-2 font-size-12 ${this.state.categoryEmpty === true || this.state.Category1LimitExceed === true ? "Error-border" : ""}`} disabled={this.state.isView} value={editcategoryValue.categoryName}
                      onInput={(e) => this.handlecategoryInputchange(e, "categoryName", "Edit")} />
                    {this.state.categoryEmpty === true ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)}
                    {this.state.Category1LimitExceed === true ? (
                      <span className="spanErrMsg">Value must be less than 250 characters</span>
                    ) : (<></>)}
                  </div>
                </div>
              </div>
              {
                !this.state.isView && <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                  <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`}
                    onClick={() => this.UpdateCategory()}>
                    <CommonIcon fileName="ButtonSubmitIcon" />
                    <span className="model-label pl-10">Update</span>
                  </button>
                </div>
              }
              {
                (this.state.isView || !this.state.isView) && editcategoryValue?.historyLog?.length > 0 && <div>
                  <div className="pt-3">
                    <h6 className="modal-title">Audit log</h6>
                  </div>
                  <div className="audit-table-wrapper audit-scroll-css">
                    <table className="px-3 audit-table w-100">
                      <thead>
                        <tr className="border-bottom">
                          <th className="p-rem">
                            Action
                          </th>
                          <th className="p-rem">
                            Action By
                          </th>
                          <th className="p-rem wid-45">
                            Description
                          </th>
                          <th className="p-rem">
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          editcategoryValue?.historyLog.map(x => (
                            <tr className="border-bottom">
                              <td className="p-rem">{x.action ? x.action : "-"}</td>
                              <td className="p-rem">{x.actionBy ? x.actionBy : "-"}</td>
                              <td className="p-rem">
                                {x.description ? x.description : "-"}
                              </td>
                              <td className="p-rem">
                                {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        {/* Category List View Search */}
        <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchCategoryScreen" aria-labelledby="offcanvasScrollingLabel">
          <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">Search</h6>
            <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas" onClick={() => { this.setState({ isSearch: false }) }}>
              <CommonIcon fileName="CrossIcon" />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                <div className="form-group">
                  <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                    <CommonIcon fileName="courseCategoryIcon" />
                    <span className="pl-10 properties-search-span">Category 1</span>
                  </label>
                  <input className={` form-control border-radius mt-2 font-size-12`}
                    onInput={(e) => {
                      this.category1Search(e)
                    }}
                    style={{ borderColor: this.state.isFieldEmpty ? "#d12232" : "" }}
                    value={this.state.searchInput} />
                  {this.state.isFieldEmpty ? (
                    <span className="send-rework-label">This field is required</span>
                  ) : (<></>)}
                </div>
              </div>
            </div>
            <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              {/* <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => {this.state.isSearch ? this.searchLevel() : this.addLevelList()}}>
                  <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10" >{this.state.isSearch ? "Search" : "Submit"}</span>
                </button> */}
              <button className="btn rejectbutton" onClick={() => this.clearSearchList()} >
                <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                <span className="px-1">Clear</span> </button>
              <button
                className={`btn approvebutton d-flex gap-1 mx-2`}
                onClick={() => { this.searchCategoryList() }}>
                <span><CommonIcon fileName="searchableIcon" /></span>
                <span className="model-label pl-vendor3 pl-2">Search</span>
              </button>
            </div>
          </div>
        </div>

        {/* Modal - Warning */}
        <WarningComponent
          message={this.state.category1ArryList?.length > 1 ? "Are you sure you want to remove these categories ?" : "Are you sure you want to remove this category ?"}
          isMobile={this.state.isMobile}
          onYesClick={() => this.DeleteCategory()}
        />

        {/* Pagination */}
        {category1List?.length !== 0 ?
          <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={this.state.totalCount} reset={pageNewCount} /> : null}
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Category1)
);
